import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import WelcomeScreen from '../ClientEnhancementUI/WelcomeScreen';
import CloseIcon from '@material-ui/icons/Close';

// const GlobalStyle = styled.createGlobalStyle`
//   body {
//     font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
//   }
// `;

export const Header = styled.header`
  background: #fff;
  border-bottom: 1px solid #d4d7dc;
  padding: 0;
`;

export const HeaderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
`;

export const LogoLink = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
`;

export const Logo = styled.span.attrs({
  className: "Link_alignLeft__ef683efb"
})`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-weight: 500;
  color: #393a3d;
`;

export const NavMenu = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;
`;
export const LeftNav = styled.div`
  display: flex;
  gap: 32px;
  margin-right: auto;
`;

export const RightNav = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const NavItem = styled.a`
  color: #393a3d;
  text-decoration: none;
  font-size: 16px;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-weight: 500;
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    color: #2ca01c;
  }
`;

export const NavButton = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  background: transparent;
  border: 1px solid #393a3d;
  color: #393a3d;
  
  &:hover {
    background: #f4f4f4;
  }
`;

const SubHeader = styled.div`
  background: #f4f4f4;
  border-bottom: 1px solid #d4d7dc;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const SubHeaderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
`;

const SubHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
`;

const ProductTitle = styled.h1`
  font-size: 24px;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-weight: 600;
  line-height: 32px;
  color: #393a3d;
  margin: 0;
`;

const SubNav = styled.nav`
  display: flex;
  gap: 30px;
  margin-left: auto;
`;

const SubNavItem = styled.a`
  color: #393a3d;
  text-decoration: none;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-weight: ${props => props.active ? '600' : '500'};
  font-size: 16px;
  line-height: 24px;
  padding: 8px 0;
  border-bottom: ${props => props.active ? '2px solid #2ca01c' : '2px solid transparent'};
  
  &:hover {
    color: #2ca01c;
  }
`;

const ConsultButton = styled.button`
  background: #2ca01c;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 4px;
  border: none;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  cursor: pointer;
  
  &:hover {
    background: #248916;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Hero = styled.section`
  position: relative;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 50%, transparent 100%), 
              url('https://quickbooks.intuit.com/oidam/intuit/sbseg/en_us/quickbooks-online/web/image/nootka-saunas-professional-services-1683-brand-photo-24-hero-QBL-US-EN-desktop@2x.jpg');
  background-size: cover;
  background-position: center;
  min-height: 680px;
  align-items: center;
  color: #ffffff;
`;

const LiveExpertBadge = styled.div`
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-transform: uppercase;
  margin-bottom: 24px;
  letter-spacing: 1.5px;
  color: #ffffff;
  text-align: left;
`;

const HeroContent = styled.div`
  max-width: 580px;
  padding: 80px 0;
  margin-left: 10px;

  h1 {
    font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
    font-size: 56px;
    font-weight: 700;
    line-height: 64px;
    margin-bottom: 24px;
    letter-spacing: -0.5px;
    color: #ffffff;
    text-align: left;
  }

  p {
    font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin-bottom: 32px;
    color: #ffffff;
    opacity: 0.9;
    text-align: left;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 40px;
  text-align: left;
`;

const PrimaryButton = styled.button`
  background: #2ca01c;
  color: #ffffff;
  padding: 16px 32px;
  border-radius: 4px;
  border: none;
  font-family: "AvenirNext forINTUIT", -apple-system, system-ui, BlinkMacSystemFont;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  min-width: 220px;
  cursor: pointer;
  text-align: center;

  &:hover {
    background: #248916;
  }
`;


const FeatureSection = styled.section`
  padding: 80px 0;
`;

const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
  margin-top: 48px;
`;

const FeatureCard = styled.div`
  padding: 32px;
  background: white;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
  }

  p {
    line-height: 1.6;
  }
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  text-align: center;
`;

const SectionText = styled.p`
  font-size: 1.25rem;
  color: #6b7177;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
`;

const QuickBooksLive = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  const handleFindExpert = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    sessionStorage.clear();
  };

  const handleModalClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseModal();
    }
  };

  return (
    <>
      <Header>
        <HeaderContainer>
          <LogoLink href="/">
            <span class="">
              <div class="flex" data-testid="RwBrand" >
                <img src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 36 36'%3e%3cpath fill='%232CA01C' d='M18 36c9.9411 0 18-8.0589 18-18 0-9.94114-8.0589-18-18-18C8.05886 0 0 8.05886 0 18c0 9.9411 8.05886 18 18 18Z'/%3e%3cpath fill='white' d='M12.0002 11c-3.86797 0-6.99996 3.136-6.99996 7 0 3.868 3.13199 7 6.99996 7h1.0001v-2.6h-1.0001c-2.42798 0-4.39995-1.972-4.39995-4.4 0-2.428 1.97197-4.4 4.39995-4.4h2.4041v13.6c0 1.436 1.1639 2.6 2.5999 2.6V11h-5.004ZM24.0038 25c3.868 0 6.9999-3.1361 6.9999-7 0-3.868-3.1319-7-6.9999-7h-1.0001v2.5999h1.0001c2.428 0 4.3999 1.9721 4.3999 4.4001s-1.9719 4.3999-4.3999 4.3999h-2.4041V8.79997c0-1.43602-1.1639-2.60002-2.5999-2.60002V25h5.004Z'/%3e%3c/svg%3e" class="icon-ball none-animation" alt="QuickBooks" width="36" height="36" data-testid="RwBrand_icon-logo" />
                <div class="clip-mask RwGlobalNav_halfWidth__d66adb9f">
                  <div data-testid="rw-brand-half-width-logo">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="116" height="38" viewBox="0 0 116 38"><path data-testid="path" d="M11.9277 38H9.1596v-7.0191h-.04776c-.71587 1.1068-2.12385 1.7996-3.66696 1.7996C2.07615 32.7805 0 30.1011 0 26.8682c0-3.2805 2.21529-5.8206 5.37323-5.8206 2.02839 0 3.27728.9914 3.83012 1.8712h.06757v-1.5487h2.65278V38h.004Zm-5.92604-7.5287c2.02839 0 3.25334-1.8234 3.25334-3.5552 0-1.7319-1.22101-3.6031-3.25334-3.6031-2.14371 0-3.18182 1.8234-3.18182 3.5552-.00395 1.7319 1.03409 3.6031 3.18182 3.6031ZM24.3604 32.458h-2.6289v-1.7797h-.0478c-.4852 1.1068-1.7976 2.1022-3.4363 2.1022-2.8834 0-4.0846-2.2176-4.0846-4.479V21.374h2.7682v6.1432c0 1.3178.2983 2.9541 2.0761 2.9541 1.7539 0 2.5852-1.5248 2.5852-3.0019V21.374h2.7681v11.084ZM27.1365 21.1313h2.7682v11.084h-2.7682v-11.084ZM40.2617 24.4438c-.4375-.625-1.3841-1.0868-2.2832-1.0868-2.0283 0-3.0465 1.8234-3.0465 3.5552 0 1.7319 1.0383 3.5554 3.1382 3.5554.8549 0 1.7975-.3464 2.3307-.9914l1.7299 1.7558c-.9232.9913-2.4464 1.5487-4.0847 1.5487-3.2773 0-5.998-2.1698-5.998-5.8644 0-3.6031 2.6772-5.8645 5.9304-5.8645 1.6149 0 3.2974.645 4.1757 1.7318l-1.8925 1.6602ZM43.5149 15h2.7682v11.0362h.0675l4.1998-4.6661h3.5516l-4.7965 5.0124 5.0989 6.0715h-3.6666l-4.3831-5.6813h-.0676v5.6813h-2.7682V15h-.004ZM58.4377 15v7.7834h.0676c.5767-.7166 1.6825-1.7319 3.7148-1.7319 3.1615 0 5.3732 2.5401 5.3732 5.8207 0 3.2329-2.0765 5.9123-5.4448 5.9123-1.5473 0-3.0472-.7167-3.8064-1.9867h-.0475v1.6642h-2.6291V15h2.7722Zm3.1616 8.313c-2.0283 0-3.2532 1.8712-3.2532 3.603 0 1.7319 1.2209 3.5553 3.2532 3.5553 2.144 0 3.1816-1.8712 3.1816-3.6031 0-1.7318-1.0376-3.5552-3.1816-3.5552ZM74.8156 21.0518c3.3448 0 6.022 2.333 6.022 5.8207 0 3.4876-2.6772 5.9122-6.022 5.9122-3.3449 0-6.0214-2.4246-6.0214-5.9122 0-3.4877 2.6765-5.8207 6.0214-5.8207Zm0 9.4197c2.1915 0 3.2057-1.8712 3.2057-3.603 0-1.7319-1.0142-3.5553-3.2057-3.5553-2.1916 0-3.2057 1.8234-3.2057 3.5553 0 1.7318 1.0141 3.603 3.2057 3.603ZM88.0595 21.0518c3.3448 0 6.0214 2.333 6.0214 5.8207 0 3.4876-2.6766 5.9122-6.0214 5.9122-3.3449 0-6.0214-2.4246-6.0214-5.9122 0-3.4877 2.6765-5.8207 6.0214-5.8207Zm0 9.4197c2.1915 0 3.2057-1.8712 3.2057-3.603 0-1.7319-1.0142-3.5553-3.2057-3.5553-2.1916 0-3.2057 1.8234-3.2057 3.5553-.004 1.7318 1.0141 3.603 3.2057 3.603ZM95.7634 15h2.7682v11.0362h.0676l4.2008-4.6661h3.551l-4.796 5.0124 5.099 6.0715h-3.668l-4.3828-5.6813h-.0676v5.6813h-2.7682V15h-.004ZM114.206 24.3282c-.485-.645-1.408-1.2024-2.422-1.2024-.875 0-1.778.3225-1.778 1.2024 0 .856.856 1.0869 2.398 1.4532 1.639.3941 3.576 1.1306 3.576 3.3005 0 2.7033-2.192 3.6946-4.613 3.6946-1.707 0-3.484-.645-4.547-1.8234l1.822-1.708c.601.7843 1.639 1.3855 2.836 1.3855.807 0 1.778-.3225 1.778-1.3178 0-.9237-.856-1.2023-2.538-1.5925-1.639-.3942-3.277-1.0631-3.277-3.1413 0-2.4723 2.215-3.5314 4.407-3.5314 1.59 0 3.253.5534 4.152 1.6841l-1.794 1.5965ZM30.0157 6.27187C30.0157 9.0035 32.2131 11 35.0059 11 37.7986 11 40 9.00741 40 6.27187V0h-2.7071v5.95077c0 1.47411-.9917 2.46077-2.2949 2.46077-1.307 0-2.2949-.98666-2.2949-2.46077V0H30l.0157 6.27187ZM48 2.56942h3.1736V11h2.6573V2.56942H57V0h-9v2.56942ZM46 0h-3v11h3V0ZM19 2.56942h3.1733V11h2.6571V2.56942H28V0h-9v2.56942ZM5 0H2v11h3V0ZM16.9922 4.7281C16.9922 1.99648 14.7899 0 11.9961 0 9.20231 0 7 1.99261 7 4.7281V11h2.70429V5.04925c0-1.47416.99221-2.46079 2.29571-2.46079s2.2957.98663 2.2957 2.46079V11H17l-.0078-6.2719Z" fill="black"></path></svg>
                  </div>
                </div>
              </div>
            </span>
          </LogoLink>
          <NavMenu>
            <LeftNav>
              <NavItem href="#">Products & features ▼</NavItem>
              <NavItem href="#">Plans & Pricing</NavItem>
              <NavItem href="#">Learn & Support ▼</NavItem>
            </LeftNav>
            <RightNav>
              <NavItem href="#">Talk to Sales: 1-844-839-7847 ▼</NavItem>
              <NavButton>Sign in ▼</NavButton>
            </RightNav>
          </NavMenu>
        </HeaderContainer>
      </Header>

      <SubHeader>
        <SubHeaderContainer>
          <SubHeaderLeft>
            <ProductTitle>QuickBooks Live</ProductTitle>
          </SubHeaderLeft>
          <SubNav>
            <SubNavItem href="#" active>Overview</SubNavItem>
            <SubNavItem href="#" >Live Expert ▼     </SubNavItem>
            <ConsultButton onClick={handleFindExpert}>Find Your Expert</ConsultButton>

          </SubNav>
        </SubHeaderContainer>
      </SubHeader>

      <Hero>
        <Container>
          <HeroContent className='ml-10'>
            <LiveExpertBadge className='left-2'>LIVE EXPERT</LiveExpertBadge>
            <h1>Trusted experts for added confidence</h1>
            <p>
              Find success at every stage. Whether you're starting out or scaling up,
              our experts can help you optimize your business as it grows and changes.
            </p>
            <ButtonGroup>
              <PrimaryButton onClick={handleFindExpert}>Find Your Expert</PrimaryButton>
              {/* <SecondaryButton>Or call 1-800-365-9606</SecondaryButton> */}
            </ButtonGroup>
          </HeroContent>
        </Container>
      </Hero>

      <Container>
        <FeatureSection>
          <SectionTitle>Work like you have a larger team behind you</SectionTitle>
          <SectionText>
            Work with trusted experts that know your business to help you stay compliant,
            interpret reports, and reveal financial insights to help you succeed.
          </SectionText>
          <FeatureGrid>
            <FeatureCard>
              <img src="https://quickbooks.intuit.com/oidam/intuit/sa/en_us/quickbooks/illustration/spot/clock-agave60-illo-spot.svg" alt="Save time and avoid extra work" />
              <h3>Save time and avoid extra work</h3>
              <p>
                Get expert help streamlining your bookkeeping and getting ready for taxes,
                so you have more time to focus on your business.
              </p>
            </FeatureCard>

            <FeatureCard>
              <img src="https://quickbooks.intuit.com/oidam/intuit/sbseg/en_us/shared/icon-feature/live-support.svg" alt="Icon for live support" />
              <h3>A full range of business expertise</h3>
              <p>
                Whether you need help with your bookkeeping, getting ready for tax time,
                or need coaching, our team of experts is here to help.
              </p>
            </FeatureCard>

            <FeatureCard>
              <img src="https://quickbooks.intuit.com/oidam/intuit/sbseg/en_us/shared/icon-feature/confidence.svg" alt="Thumbs up icon" />

              <h3>Trusted experts plus powerful tools</h3>
              <p>
                Connect with experts year-round for advice and guidance, with best-in-class
                tools to support you as your business grows.
              </p>
            </FeatureCard>
          </FeatureGrid>
        </FeatureSection>
      </Container>

      {showModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
          onClick={handleModalClick}
        >
          <div className="bg-white rounded-lg relative max-w-[700px] max-h-[700px] min-h-[500px] " style={{ maxHeight: '650px', maxWidth: '900px', overflow: 'auto' }}>
            <button
              onClick={handleCloseModal}
              className="absolute right-4 top-4 text-gray-500 hover:text-gray-700 z-10 "
            >
              <CloseIcon />
            </button>
            <div className="overflow-y-auto">
              <WelcomeScreen
                onClose={() => {
                  handleCloseModal();
                  // Reset WelcomeScreen state
                  sessionStorage.clear();
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default QuickBooksLive; 